import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  IBillingTransactions,
  IInstalmentPlanInformation,
} from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-instalment-plan-card',
  templateUrl: './my-bill-instalment-plan-card.component.html',
  standalone: false,
})
export class MyBillInstalmentPlanCardComponent implements OnInit {
  @Input() instalmentPlanInformation: IInstalmentPlanInformation;
  @Input() transactions: IBillingTransactions;

  progressBarContent = {
    minValue: 0,
    maxValue: 0,
    currentValue: 0,
    usageDataAlreadyUsed: '',
    usageDataRemaining: '',
  };
  eligibleToDisplayProgressBar = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (
      this.instalmentPlanInformation.sliceDetails?.length > 0 &&
      this.instalmentPlanInformation.paidAmount &&
      this.instalmentPlanInformation.totalAmount
    ) {
      this.eligibleToDisplayProgressBar = true;
    }
  }

  onClickOnInstalmentPlanCard() {
    this.router.navigate(['instalmentPlanDetails'], {
      state: {
        instalmentPlanInformation: this.instalmentPlanInformation,
        transactions: this.transactions,
      },
    });
  }
}
